export default [
  {
    path: '/order/order-auth',
    meta: { title: '店铺信息' },
    component: () => import('../../pages/order/order-auth.vue'),
  },
  {
    path: '/order/myorder',
    meta: { title: '我的订单' },
    component: () =>
      import(/* webpackChunkName: "myorder" */ '../../pages/order/myorder.vue'),
  },
  {
    path: '/order/checkorder',
    meta: {
      title: '订单详情',
      fromType: 'checkorder',
      storePath: '/store/checkorder',
      cacheKey: 'OrderKPI',
    },
    component: () =>
      import(
        /* webpackChunkName: "checkorder" */ '../../pages/order/checkorder.vue'
      ),
  },
  {
    path: '/order/setorder',
    meta: { title: '确认订单' },
    component: () =>
      import(
        /* webpackChunkName: "setorder" */ '../../pages/order/setorder.vue'
      ),
  },
  {
    path: '/order/cartSetOrder',
    meta: { title: '确认订单' },
    component: () =>
      import(
        /* webpackChunkName: "setorder" */ '../../pages/order/cartSetOrder.vue'
      ),
  },
  {
    path: '/order/edit-address',
    meta: { title: '修改地址' },
    component: () =>
      import(
        /* webpackChunkName: "setorder" */ '../../pages/order/EditAddress.vue'
      ),
  },
  {
    path: '/order/snapshot',
    meta: { title: '商品快照' },
    component: () =>
      import(
        /* webpackChunkName: "GoodsSnapshot" */ '../../pages/order/GoodsSnapshot.vue'
      ),
  },
  {
    path: '/order/trainOrderDetail',
    meta: { title: '订单详情' },
    component: () =>
      import(
        /* webpackChunkName: "GoodsSnapshot" */ '../../pages/order/TrainOrderDetail.vue'
      ),
  },
  // 电商专员角色专用（管理、创建者也可见），仅查看无操作
  {
    path: '/order/list',
    meta: { title: '订单列表' },
    component: () =>
      import(
        /* webpackChunkName: "GoodsSnapshot" */ '../../pages/order/orderList.vue'
      ),
  },
]
